<template>
  <div class="timeline">
    <template v-for="(state, index) of submittedApplicationStates">
      <div class="timeline-item" v-bind:key="state.id" :class="timelineItemClass(state.slug, index)">
        <div class="timeline-icon">
          <Icon :icon-name="timelineIconName(state.slug, index)" />
        </div>
        <div class="timeline-item-details" :class="`status-${state.slug}`">
          <h6>{{getTitleForStatus(state)}}</h6>
          <SubmitApplicationStageComponent v-if="state.slug === 'SUBMIT'" :application="application"/>
          <InReviewStageComponent v-if="state.slug === 'REVIEW'" :application="application" />
          <CancelledStageComponent v-if="['WITHDRAWN', 'REJECTED'].includes(state.slug)" :application="application" />
          <ApprovedStageComponent v-if="state.slug === 'APPROVED'" :application="application" />
          <SigningStageComponent v-if="state.slug === 'SIGNING'" :application="application"/>
          <SignedStageComponent v-if="state.slug === 'SIGNED'" :application="application"/>
          <CollectCashStageComponent v-if="state.slug === 'PAYMENT'" :application="application" />
          <PaidOutApplicationStageComponent v-if="state.slug === 'COMPLETED'" :application="application" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Icon from '@shared/components/Icon'
import SignedStageComponent from '@shared/components/timeline/SignedStageComponent'
import SigningStageComponent from '@/components/timeline/SigningStageComponent'
import CollectCashStageComponent from '@shared/components/timeline/CollectCashStageComponent'
import SubmitApplicationStageComponent from '@shared/components/timeline/SubmitApplicationStageComponent'
import ApprovedStageComponent from '@shared/components/timeline/ApprovedStageComponent'
import PaidOutApplicationStageComponent from '@shared/components/timeline/PaidOutApplicationStageComponent'
import TimelineMixin from '@shared/components/timeline/TimelineMixin'
import CancelledStageComponent from '@shared/components/timeline/CancelledStageComponent'
import InReviewStageComponent from '@shared/components/timeline/InReviewStageComponent'

export default {
  name: 'LoanApplicationTimeline',
  components: {
    PaidOutApplicationStageComponent,
    ApprovedStageComponent,
    CancelledStageComponent,
    Icon,
    SignedStageComponent,
    SigningStageComponent,
    CollectCashStageComponent,
    SubmitApplicationStageComponent,
    InReviewStageComponent
  },
  mixins: [TimelineMixin],
  props: ['application'],
  data () {
    return {
      submittedApplicationStates: [
        { slug: 'SUBMIT', title: 'SUBMIT' },
        { slug: 'REVIEW', title: 'REVIEW' },
        { slug: 'APPROVED', title: 'REVIEW' },
        { slug: 'SIGNING', title: 'APPROVED' },
        { slug: 'SIGNED', title: 'APPROVED' },
        { slug: 'PAYMENT', title: 'SIGNED' },
        { slug: 'COMPLETED', title: 'COMPLETED' }
      ],
      withdrawnPath: [
        { slug: 'SUBMIT', title: 'SUBMIT' },
        { slug: 'WITHDRAWN', title: 'WITHDRAWN' }
      ],
      rejectedPath: [
        { slug: 'SUBMIT', title: 'SUBMIT' },
        { slug: 'REJECTED', title: 'REJECTED' }
      ]
    }
  },
  created() {
    if (this.application.status === 'WITHDRAWN') {
      this.submittedApplicationStates = this.withdrawnPath
    }
    if (this.application.status === 'REJECTED') {
      this.submittedApplicationStates = this.rejectedPath
    }
    if (this.application.status === 'REVIEW') {
      this.removeTimelineStep('APPROVED')
      this.removeTimelineStep('SIGNING')
      this.removeTimelineStep('PAYMENT')
      this.removeTimelineStep('COMPLETED')
    }
    if (this.application.status === 'APPROVED') {
      this.removeTimelineStep('REVIEW')
    }
    if (this.application.status === 'SIGNING') {
      this.removeTimelineStep('REVIEW')
      this.removeTimelineStep('SIGNED')
      this.removeTimelineStep('COMPLETED')
    }
    if (this.application.status === 'PAYMENT') {
      this.removeTimelineStep('REVIEW')
      this.removeTimelineStep('SIGNING')
      this.removeTimelineStep('COMPLETED')
    }
    if (this.application.status === 'COMPLETED') {
      this.removeTimelineStep('REVIEW')
      this.removeTimelineStep('SIGNING')
      this.removeTimelineStep('PAYMENT')
    }
  },
  methods: {
    removeTimelineStep(name) {
      const index = this.submittedApplicationStates.findIndex((step) => step.slug === name)
      this.submittedApplicationStates.splice(index, 1)
    }
  }
}
</script>
